import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PollEditor = ({ content, onChange }) => {
  const handleChange = (field, value) => {
    onChange({
      ...content,
      [field]: value
    });
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...(content?.options || ['', '', '', ''])];
    newOptions[index] = value;
    handleChange('options', newOptions);
  };

  const addOption = () => {
    const newOptions = [...(content?.options || []), ''];
    handleChange('options', newOptions);
  };

  const removeOption = (index) => {
    const newOptions = (content?.options || [])?.filter((_, i) => i !== index);
    handleChange('options', newOptions);
  };

  const options = content?.options || ['', '', '', ''];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="BarChart3" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
            Anket İçeriği
          </h4>
          <p className="caption text-muted-foreground">
            Kullanıcılara soracağınız soruyu ve seçenekleri belirleyin
          </p>
        </div>
      </div>
      <Input
        label="Anket Sorusu"
        type="text"
        placeholder="Örn: En çok hangi trafik kuralına dikkat ediyorsunuz?"
        value={content?.question || ''}
        onChange={(e) => handleChange('question', e?.target?.value)}
        required
        description="Açık ve anlaşılır bir soru sorun"
      />
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <label className="block text-sm font-medium text-foreground">
            Anket Seçenekleri
            <span className="text-destructive ml-1">*</span>
          </label>
          <span className="caption text-muted-foreground">
            {options?.length} seçenek
          </span>
        </div>

        {options?.map((option, index) => (
          <div key={index} className="flex gap-3">
            <div className="flex-1">
              <Input
                type="text"
                placeholder={`Seçenek ${index + 1}`}
                value={option}
                onChange={(e) => handleOptionChange(index, e?.target?.value)}
                required={index < 3}
              />
            </div>
            {options?.length > 3 && (
              <Button
                variant="outline"
                size="default"
                onClick={() => removeOption(index)}
                iconName="X"
                className="flex-shrink-0"
              />
            )}
          </div>
        ))}

        {options?.length < 6 && (
          <Button
            variant="outline"
            size="default"
            onClick={addOption}
            iconName="Plus"
            iconPosition="left"
            fullWidth
          >
            Seçenek Ekle
          </Button>
        )}
      </div>
      <div className="p-4 md:p-6 rounded-lg bg-accent/10 border border-accent/20">
        <div className="flex items-start gap-3">
          <Icon name="TrendingUp" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-foreground font-medium mb-1">
              Canlı Sonuçlar
            </p>
            <p className="caption text-muted-foreground">
              Kullanıcılar oy verdikten sonra anlık sonuçları yüzde olarak görebilecekler. Minimum 3, maksimum 6 seçenek ekleyebilirsiniz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PollEditor;